import React from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Logo from "../../static/titleLogo.jpg";
import USPDocuments from "../../static/documents.png";
import USPCommercial from "../../static/commercial.png";
import USPInterface from "../../static/interfaces.png";
import USPPrivacy from "../../static/privacy.png";
import USPTopics from "../../static/topics.png";
import USPUpToDate from "../../static/up-to-date.png";
import "./index.scss";
import SimpleCard from "../coponents/card";
import SimpleAccordion from "../coponents/accordion";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

function Copyright() {
  return (
    <div className="footer">
      <Typography variant="body2" color="textSecondary" align="center">
        {"Ein Produkt der "}
        <Link color="inherit" href="https://quizco.de/">
          QuizCo GmbH©
        </Link>{" "}
        {" | "}
        <Link color="inherit" href="https://quizco.de/impressum/">
          Impressum
        </Link>
        {" | "}
        <Link color="inherit" href="https://quizco.de/datenschutzerklaerung/">
          Datenschutz
        </Link>
      </Typography>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonProgress: {
    color: "#ffd966",
    position: "absolute",
    //top: "50%",
    left: "50%",
    marginTop: 4,
    marginLeft: -12,
  },
  largeInput: {
    height: 300,
  },
}));



export default function SignUp() {
  const CHARACTER_LIMIT = 1000;
  const [values, setValues] = React.useState({
    name: "",
    extraInputParameter: 1,
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [response, setResponse] = React.useState("");
  const classes = useStyles();
  const [state, setState] = React.useState({
    age: "1",
    name: "Quiz",
    parameterVariation: "",
  });
  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const preProcessText = (text) => {
    text = text.replace(/\r?\n|\r/, " ")
    text = text.replace(/"/g, '')
    text = text.replace(/'/g, '')
    return text
  }

  const CTALink = "https://quizco.de/content-processor/";

  const RequestQuestion = (values) => {
    const axios = require("axios").default;
    setIsLoading(true);
    axios
      .post("https://europe-west1-ai-frontend-premium-dev.cloudfunctions.net/api/de/openQuestion",
        {
          text: preProcessText(values),
          "auth_key": "5561c36e-c3e9-4273-bc0c-88d13deb84a5",
        }
      )
      .then(function (response) {
        var responseString = "";
        response.data.map((u) => {
          responseString =
            responseString + u.question + "\n \n";
        });
        setResponse(responseString);
        setIsLoading(false);
      })
      .catch(function (error) {
        setResponse("Fehlerhafte Eingabe");
        setIsLoading(false);
      });
  };

  const RequestExtractiveSummarization = (values) => {
    const axios = require("axios").default;
    setIsLoading(true);
    axios
      .post("https://europe-west1-ai-frontend-premium-dev.cloudfunctions.net/api/de/keySentences",
        {
          text: preProcessText(values),
          amount: 3,
          "auth_key": "5561c36e-c3e9-4273-bc0c-88d13deb84a5",
        }
      )
      .then(function (response) {
        var responseString = "";
        response.data.map((u) => {
          responseString =
            responseString + u["key-Sentences"] + "\n \n";
        });
        setResponse(responseString);
        setIsLoading(false);
      })
      .catch(function (error) {
        setResponse("Fehlerhafte Eingabe");
        setIsLoading(false);
      });
  };

  const RequestSummarization = (values, extraInputParameter) => {
    const axios = require("axios").default;
    setIsLoading(true);
    axios
      .post("https://europe-west1-ai-frontend-premium-dev.cloudfunctions.net/api/de/summary", {
        text: preProcessText(values),
        "auth_key": "5561c36e-c3e9-4273-bc0c-88d13deb84a5",
      })
      .then(function (response) {
        setResponse(response.data.summary);
        setIsLoading(false);
      })
      .catch(function (error) {
        setResponse("Fehlerhafte Eingabe");
        setIsLoading(false);
      });
  };


  const RequestVariation = (values, extraInputParameter) => {
    const axios = require("axios").default;
    setIsLoading(true);
    axios
      .post("https://europe-west1-ai-frontend-premium-dev.cloudfunctions.net/api/de/variation", {
        text: preProcessText(values),
        "auth_key": "5561c36e-c3e9-4273-bc0c-88d13deb84a5",
      })
      .then(function (response) {
        setResponse(response.data.variation);
        setIsLoading(false);
      })
      .catch(function (error) {
        setResponse("Fehlerhafte Eingabe");
        setIsLoading(false);
      });
  };

  const RequestClozeQuestion = (values) => {
    const axios = require("axios").default;
    setIsLoading(true);
    axios
      .post("https://europe-west1-ai-frontend-premium-dev.cloudfunctions.net/api/de/gapQuestion", {
        text: preProcessText(values),
        "auth_key": "5561c36e-c3e9-4273-bc0c-88d13deb84a5",
      })
      .then(function (response) {
        var output = ""
        var distractorLimit = 5;
        response.data.map((question) => {
          output = output + question.question + "\n \n ☐ " + question.answer + " \n \n";
          question.distractors.map((distractor, index) => {
            if (index >= distractorLimit) {
              return;
            }
            output += " ☐ " + distractor + "\n \n";
          })
        })
        setResponse(output);
        setIsLoading(false);
      })
      .catch(function (error) {
        setResponse("Fehlerhafte Eingabe");
        setIsLoading(false);
      });
  };

  const getCookie = function (name) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return match[2];
  };



  const hubspotRequest = (inputText, email, ai_service_option, userIP) => {
    const axios = require("axios").default;
    axios.post("https://europe-west3-quizcoai.cloudfunctions.net/get-user-ip-service", {})
      .then(function (response) {
        userIP = response.data;

        var xhr = new XMLHttpRequest();
        var cookie = getCookie("hubspotutk");
        var url =
          "https://api.hsforms.com/submissions/v3/integration/submit/5804811/84eeef0a-35d4-43ee-8faf-3cbdf16d6fe8";
        // In var url above, replace portalId and formId with your values from HubSpot.
        // Example request JSON:
        var data = {
          submittedAt: Date.now(),
          fields: [
            {
              name: "email",
              value: email,
            },
            {
              name: "content_eingabe",
              value: inputText,
            },
            {
              name: "ki_service",
              value: ai_service_option
            },
          ],
          context: {
            pageUri: "https://content-processor.com",
            pageName: "content-processor-demo",
            hutk: cookie,
            ipAddress: userIP,
          },
          legalConsentOptions: {
            // Include this object when GDPR options are enabled
            consent: {
              consentToProcess: true,
              text:
                "QuizCo benötigt die Kontaktinformationen, die Sie uns zur Verfügung stellen, um Sie bezüglich unserer Produkte und Dienstleistungen zu kontaktieren. Sie können sich jederzeit von diesen Benachrichtigungen abmelden. Informationen zum Abbestellen sowie unsere Datenschutzpraktiken und unsere Verpflichtung zum Schutz Ihrer Privatsphäre finden Sie in unseren Datenschutzbestimmungen.",
              communications: [
                {
                  value: true,
                  subscriptionTypeId: 999,
                  text:
                    "QuizCo benötigt die Kontaktinformationen, die Sie uns zur Verfügung stellen, um Sie bezüglich unserer Produkte und Dienstleistungen zu kontaktieren. Sie können sich jederzeit von diesen Benachrichtigungen abmelden. Informationen zum Abbestellen sowie unsere Datenschutzpraktiken und unsere Verpflichtung zum Schutz Ihrer Privatsphäre finden Sie in unseren Datenschutzbestimmungen.",
                },
              ],
            },
          },
        };
        var final_data = JSON.stringify(data);
        xhr.open("POST", url);
        // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            //alert(xhr.responseText) // Returns a 200 response if the submission is successful.
          } else if (xhr.readyState == 4 && xhr.status == 400) {
            //alert(xhr.responseText) // Returns a 400 error the submission is rejected.
          } else if (xhr.readyState == 4 && xhr.status == 403) {
            //alert(xhr.responseText) // Returns a 403 error if the portal isn't allowed to post submissions.
          } else if (xhr.readyState == 4 && xhr.status == 404) {
            //alert(xhr.responseText) //Returns a 404 error if the formGuid isn't found
          }
        };
        // Sends the request
        xhr.send(final_data);
      })
      .catch(function (error) {
        return "error"
      });
  }


  const handleClick = (option, inputText, email, checkboxPrivacy, extraInputParameter, userIP) => {
    var error = "";
    if (!inputText || inputText.length < 3) {
      error = error + "❌ Die Texteingabe war zu kurz.\n\n";
    }

    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
      error = error + "❌ Die E-Mailadresse ist nicht zulässig.\n\n";
    }

    if (!checkboxPrivacy) {
      error =
        error + "❌ Bitte bestätigen Sie die Datenschutzbestimmungen.\n\n";
    }

    if (error.length > 0) {
      let errorWithCarriageReturn = error.split("\n").map((item, i) => {
        return <p key={i}>{item}</p>;
      });
      setErrorMessage(errorWithCarriageReturn);
      setOpen(true);
      return;
    }
    hubspotRequest(inputText, email, option, userIP);
    if (option == 1) {
      RequestQuestion(inputText);
    }
    if (option == 2) {
      RequestSummarization(inputText, extraInputParameter);
    }
    if (option == 3) {
      RequestClozeQuestion(inputText);
    }
    if (option == 4) {
      RequestVariation(inputText, extraInputParameter);
    }
    if (option == 5) {
      RequestExtractiveSummarization(inputText);
    }

  };

  const handleChangeOnInput = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  return (
    <div className="index">
      <div className="header">
        <img src={Logo} className="logo" alt="Content-Processor Logo" />
      </div>
      <Container maxWidth="m">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className="title" component="h2" variant="h4">
            Teste Sie den Demo-Content-Processor!
          </Typography>
          <br />
          <form className={classes.form}>
            <Box
              display="flex"
              flexWrap="wrap"
              flexDirection="row"
              justifyContent="center"
            >
              <Box className="boxContainer">
                <TextField
                  multiline
                  rows={24}
                  variant="outlined"
                  required
                  fullWidth
                  color="#000"
                  inputProps={{
                    maxlength: CHARACTER_LIMIT,
                  }}
                  id="inputText"
                  label="Text eingeben (Englisch)"
                  name="inputText"
                  autoComplete="text"
                  onChange={handleChangeOnInput("name")}
                  placeholder="Hier können Sie bis zu 1000 Zeichen eingeben."
                  helperText={`${values.name.length}/${CHARACTER_LIMIT}`}
                />
              </Box>

              <Box className="boxContainer">
                <FormControl fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="age-native-simple">
                    Spracheinstellungen
                  </InputLabel>
                  <Select native>
                    {/* <option aria-label="None" value="" /> */}
                    <option selected value={1}>
                      Deutsch
                    </option>
                    <option disabled value={2}>
                      Englisch (Premium)
                    </option>
                  </Select>
                </FormControl>
                <br />
                <br />
                <FormControl fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="age-native-simple">
                    Ausgabeformat
                  </InputLabel>
                  <Select
                    native
                    value={state.age}
                    onChange={handleChange}
                    inputProps={{
                      name: "age",
                      id: "age-native-simple",
                    }}
                  >
                    {/* <option aria-label="None" value="" /> */}
                    <option selected value={1}>
                      Fragen
                    </option>
                    <option value={4}>
                      Variation
                    </option>
                    <option value={5}>
                      Kernaussagen
                    </option>
                    <option value={2}>
                      Zusammenfassung
                    </option>
                    <option value={3}>
                      Lücken-Quiz
                    </option>

                  </Select>
                </FormControl>


                {extraInputParameterRenderer()}
                <br />
                <br />
                <Grid item xs={16}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="email"
                    label="E-Mail"
                    type="email"
                    id="email"
                    onChange={handleChangeOnInput("email")}
                  />
                </Grid>
                <br /> <br />
                <Grid item xs={12}>
                  <Button
                    //type="submit"
                    fullWidth
                    variant="contained"
                    className="button"
                    onClick={() => {
                      handleClick(
                        state.age,
                        values.name,
                        values.email,
                        values.checkboxPrivacy,
                        values.extraInputParameter
                      );
                    }}
                    disabled={isLoading}
                  >
                    Generieren
                  </Button>
                  {isLoading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Grid>
                <br />
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleChangeOnInput("checkboxPrivacy")}
                        value="allowExtraEmails"
                        color="primary"
                      />
                    }
                    label="QuizCo benötigt die Kontaktinformationen, die Sie uns zur Verfügung stellen, um Sie bezüglich unserer Produkte und Dienstleistungen zu kontaktieren. Sie können sich jederzeit von diesen Benachrichtigungen abmelden. Informationen zum Abbestellen sowie unsere Datenschutzpraktiken und unsere Verpflichtung zum Schutz Ihrer Privatsphäre finden Sie in unseren Datenschutzbestimmungen."
                  />
                </Grid>
              </Box>

              <Box className="boxContainer">
                <TextField
                  label="Ausgabe"
                  multiline
                  rows={24}
                  value={response}
                  variant="outlined"
                  width="300px"
                  helperText="Die Demoinhalte sind nicht für die kommerzielle Nutzung zugelassen."
                />
              </Box>
            </Box>
          </form>
        </div>
      </Container>
      <div className="qAndA">
        <Button
          variant="contained"
          href="https://meetings.hubspot.com/torsten-hasenclever"
          className="button-cta"
          onClick={() => { }}
        >
          Kontakt Aufnehmen
        </Button>
        <br />
        <br />
        <Typography className="title" component="h3" variant="h4">
          Content-Processor Premium - schnell, präzise und sicher
        </Typography>
        <br />
        <br />
        <br />

        <div className="USPContainer">
          <SimpleCard
            image={USPDocuments}
            title="Unsere KI verarbeitet ganze Dokumente, ohne Zeichenbegrenzung"
            text="Für die Verarbeitung Ihres Auftrags gibt es keine Zeichenbegrenzung! Außerdem steht Ihnen eine breite Palette an unterschiedlichen Dokumententypen zur Auswahl."
          />

          <SimpleCard
            image={USPTopics}
            title="Der Content-Processor passt sich individuell an alle Themen an"
            text="Unsere KI kann leicht an Ihre Anforderungen angepasst werden. Bestimmen Sie ganz einfach den Themenschwerpunkt, den Schwierigkeitsgrad oder mehr."
          />
          <SimpleCard
            image={USPUpToDate}
            title="Durch stetige Verbesserungen immer Up To Date bleiben"
            text="Mit Content-Processor Premium bekommen Sie immer die neusten, besten und größten KI-Modelle direkt aus unserem Forschungslabor. Profitieren sie vom Fortschritt!"
          />
          {/* </Grid>
        <Grid container spacing={7}> */}
          <SimpleCard
            image={USPPrivacy}
            title="Wir legen wert auf Datenschutz, damit Ihre Daten sicher sind"
            text="Die Verarbeitung Ihrer Daten unterliegt höchsten Datenschutzstandards und Ihre Dokumente werden unmittelbar nach der Verarbeitung gelöscht."
          />
          <SimpleCard
            image={USPCommercial}
            title="Für die Erstellung von kommerziellen Texten erschaffen"
            text="Als Premium Kunde erhalten Sie das volle Nutzungsrecht. Die Inhalte unserer Demo dürfen ausdrücklich nicht zu kommerziellen Zwecken verwendet werden."
          />
          <SimpleCard
            image={USPInterface}
            title="Zahlreiche Daten für eine Vielzahl von Schnittstellen"
            text="Sie betreiben ein Lernmanagementsystem und benötigen spezielle Ausgabeformat? Der Content-Processor unterstützt eine Vielzahl von Schnittstellen."
          />
        </div>
        <br />
        <br />
        <Button
          variant="contained"
          href={CTALink}
          className="button-cta"
          onClick={() => { }}
        >
          Weitere Informationen
        </Button>
        <br />
        <br />
        <br />
        <Typography className="title" component="h3" variant="h4">
          Content-Processor Premium - direkt starten 🚀
        </Typography>
        <br />
        <br />
        <div className="elopage-products">
          <div id='elopage-widgets-container' data-token='cyoh2fzwQ2KtoK9Ts6Sv'></div>
          <div id='elopage-widgets-container' data-token='e19wiPpGUyGrfsmYFj1i'></div>
          <div id='elopage-widgets-container' data-token='ViZXcTzSxYb5xpzLxKsR'></div>
        </div>

        <br />
        <Button
          variant="contained"
          href="https://meetings.hubspot.com/torsten-hasenclever"
          className="button-cta"
          onClick={() => { }}
        >
          Individuelles Angebot
        </Button>
        <Typography className="title" component="h3" variant="h4">
          Häufig gestellte Fragen
        </Typography>
        <br />
        <div className="accordionContainer">
          <SimpleAccordion
            title="Welche Art von Dateien eignen sich für den Content-Processor?"
            text="Am besten funktioniert die Fragenerstellung mit aussagekräftigen Texten. Verwenden Sie einen Text, der mindestens 300 Zeichen lang ist. Sie sollten jedoch auch darauf achten, dass der Text nicht zu lang ist und möglichst wenig Sonderzeichen beinhaltet."
          />
          <SimpleAccordion
            title="Welche Kosten fallen durch den Content-Processor an?"
            text="Damit Sie die Künstliche Intelligenz von QuizCo umfangreicher und öfter nutzen kannst, fallen Kosten ab 5,00 € pro analysierter Seite (Standard DIN A4). Sprich uns gerne an und wir erstellen dir ein unverbindliches Angebot."
          />
          <SimpleAccordion
            title="Warum sollte ich eine KI für mich arbeiten lassen?"
            text="Natürlich können Sie auch selbst Abfragen und Lernstandskontrollen erstellen, aber wer hat die Lust und Zeit dazu, sich stundenlang Texte durchzulesen und entsprechende, sinnvolle Abfragen zu entwickeln? Diese Aufgabe übernimmt ganz einfach die Künstliche Intelligenz und Sie können die gewonnene Zeit sinnvoller investieren!"
          />
          <SimpleAccordion
            title="Wie arbeitet die KI des Content-Processor?"
            text="Einfach zusammengefasst: Die KI analysiert den hochgeladenen Text, versteht diesen und erstellt darauf basierend zum Beispiel Fragen."
          />
        </div>
        <br />
        <br />

        <br />
        <Button
          variant="contained"
          href="https://meetings.hubspot.com/torsten-hasenclever"
          className="button-cta"
          onClick={() => { }}
        >
          Kontakt Aufnehmen
        </Button>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>{" "}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Fehlerhafte Eingabe"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  function extraInputParameterRenderer() {
    if (state.age == 4) {
      return (<><br />
        <br />
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel htmlFor="age-native-simple">
            Stärke der Variation
          </InputLabel>
          <Select
            native

            onChange={handleChangeOnInput("extraInputParameter")}
            inputProps={{
              name: "age",
              id: "age-native-simple",
            }}
          >
            {/* <option aria-label="None" value="" /> */}
            <option disabled value={0}>
              Leicht (Premium)
            </option>
            <option selected value={1}>
              Mittel
            </option>
            <option disabled value={2}>
              Stark (Premium)
            </option>
          </Select>
        </FormControl></>)
    } else if (state.age == 2) {
      return (<><br />
        <br />
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel htmlFor="age-native-simple">
            Stärke der Komprimierung
          </InputLabel>
          <Select
            native

            onChange={handleChangeOnInput("extraInputParameter")}
            inputProps={{
              name: "age",
              id: "age-native-simple",
            }}
          >
            {/* <option aria-label="None" value="" /> */}
            <option disabled value={0}>
              Leicht (Premium)
            </option>
            <option selected value={1}>
              Mittel
            </option>
            <option disabled value={2}>
              Stark (Premium)
            </option>
          </Select>
        </FormControl></>)

    }

  }
}
